 <template>
    <v-container fluid grid-list-lg>
        <v-card>
          <v-toolbar>
            <v-icon>new_releases</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Manejo de Consultas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <!-- <v-row>
                <v-col cols ="3">
                    <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                        item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
            </v-row> -->
            <v-layout row>
              
               <v-flex xs12 sm6 md3 lg3>
                <v-text-field v-model="filtro.documento" label="Buscar por documento">
                    </v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md3 lg3>
                <v-text-field v-model="filtro.telefono" label="Buscar por Telefono">
                    </v-text-field>
              </v-flex>
             
              <v-flex xs12 sm6 md3 lg3>
                <v-text-field v-model="filtro.nombre" label="Buscar por Nombre">
                    </v-text-field>
              </v-flex>
                <v-flex xs6 class="hidden-sm-and-down"> </v-flex>

                <v-flex xs12 sm6 md3 lg3>
                <app-selector-periodos v-on:update-periodo="filtro.periodo = $event"></app-selector-periodos>    
              </v-flex>
              
              <v-col cols="2">
                  <v-btn color="success" @click="getItems(true)">Traer Consultas</v-btn>
              </v-col>
            </v-layout>
            
            <v-flex>
                <v-card >
                  <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Lista de Consultas</v-toolbar-title>
                    <v-spacer></v-spacer>                      
                  </v-toolbar>
                
                  <v-data-table dense
                    :headers="headers"
                    :items="records"
                    :server-items-length="totalItems"
                    :rows-per-page="pagination.rowsPerPage"                      
                    :options.sync ="pagination"
                    v-model="selectedRow"
                    :loading="loading"                      
                    :footer-props="footer" 
                    item-key="id"                    
                  >
                  <template v-slot:item="{item}">
                      <!-- <tr @click="viewItem(item)" v-bind:class="[(selectedRow[0] && (selectedRow[0].id == item.id)) ? 'grey lighten-2': 'white']"> -->
                    <tr>
                        <td class="text-xs-left caption">{{ item.documento }}</td>
                        <td class="text-xs-left caption">{{ item.sectorOrigenDescripcion }}</td>
                        <td class="text-xs-left caption" >{{ item.nombre }}</td>
                        <td class="text-xs-left caption">{{ item.resultadoDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.telefono }}</td>
                        <td class="text-xs-left caption">{{ item.email }}</td>
                        <td class="text-xs-left caption">{{ item.fecha | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                        <td class="text-xs-left caption">{{ item.tipoClienteDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.canalConsultaDescripcion}}</td>
                        <td class="text-xs-left caption">{{ item.motivoConsultaDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.respuestaMotorDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.motivoRechazoDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.canalDerivadoDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.bancoDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.situacionLaboralActividadDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.responsableCarga}}</td>
                        <td>
                            <v-icon small  @click="viewItem(item)">remove_red_eye</v-icon>
                            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                            <!-- <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon> -->
                        </td>
                    </tr>
                    </template>
                  </v-data-table>
                </v-card >
            </v-flex>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="nuevaConsulta" >Nueva Consulta</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="procesarReporte" >Generar Reporte</v-btn>
          </v-card-actions>
          
        </v-card >
        
      
          
        <app-loading :loading="loading"></app-loading>

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    /* components: {
    'alta-consulta': AltaConsulta
  }, */
  data() {
    return {
      primeraBusquedaRealizada:false,
      selectedPersonaBusqueda: null,
      ingresoPor: 'documento',
      filtrarPor:'',
      loading: false,
      suspend: false,
      filterChanged:false,
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Documento', value: 'documento',},
        { text: 'Sector Origen', value: 'sectorOrigenDescripcion',},
        { text: 'Nombre', value: 'nombre'},
        { text: 'Resultado', value: 'resultadoDescripcion',},
        { text: 'Teléfono', value: 'telefono',sortable : false},
        { text: 'Email', value: 'email',sortable : false},
        { text: 'Fecha', value: 'fecha',sortable : false},
        { text: 'Tipo Cliente', value: 'clienteDescripcion',sortable : false},
        { text: 'Canal Consulta', value: 'canalConsultaDescripcion',sortable: false},
        { text: 'Motivo Consulta', value: 'motivoConsultaDescripcion',sortable: false},
        { text: 'Respuesta Motor', value: 'respuestaMotorDescripcion',sortable: false},
        { text: 'Motivo Rechazo', value: 'motivoRechazoDescripcion',sortable: false},
        { text: 'Canal Derivado', value: 'canalDerivadoDescripcion',sortable : false},
        { text: 'Banco', value: 'bancoDescripcion',sortable: false},
        { text: 'Situacion Laboral', value: 'situacionLaboralActividadDescripcion',sortable: false},
        { text: 'Responsable', value: 'responsableCarga',sortable : false},
        { text: 'Acciones', value: 'accion', width:80, sortable:false },
      ],
      records: [], // registros
      selectedRow: [],
      filtro: {documento:'',telefono:'',nombre:'', periodo:{id:1}},
      listEmpresas: []
    };
  },
  async created() {   
      this.loadEmpresas();
  
  },  
  watch: {
    pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    },
    'activeTask':function(){
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if(this.closeRelatedTasks)
      {
          this.getItems(false);
      }
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink',
                    'user','activeTask','getActionFromLink','user','closeRelatedTasks']),
    action: function(){
      return this.getActionFromLink(this.$route.path) 
    },
    canCreate: function(){
            return this.checkCanCreate(this.$route.path)
        },
        canUpdate: function(){
            return this.checkCanUpdate(this.$route.path)
        },
        canDelete: function(){
            return this.checkCanDelete(this.$route.path)
        },
  },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async getItems(resetPagination) {
      if(this.filtro.periodo.desde === undefined)
      {
        this.alertWarning('Debe elegir un periodo para la búsqueda.');
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if(resetPagination)
      {
        this.pagination.page = 1
      }

      this.loading = true
      this.$validator.reset()

      let filter = this.filtro;
      
      
      try {
        var result = await http.get('manejoconsulta?empresaId='+this.filtro.empresaId + '&documento=' + filter.documento + '&nombre='+ filter.nombre
                                    + '&telefono='+ filter.telefono
                                    + '&fechaDesde=' + filter.periodo.desde + '&fechaHasta=' + filter.periodo.hasta
                                    + '&limit='+this.pagination.itemsPerPage+'&page='+this.pagination.page 
                                    + '&sortby='+this.pagination.sortBy+'&descending='+(this.pagination.sortDesc.length > 0 ? this.pagination.sortDesc : 'false') );
        
        this.records = result.list;
        Vue.$log.debug(this.records)
        
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.primeraBusquedaRealizada = true
      this.loading = false
    },
    async loadEmpresas(){
      this.loading = true;
      try{
        var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

        this.listEmpresas = result.list;
        this.listEmpresas.unshift({id:0,nombre:'(Todas)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async nuevaConsulta(){
        var params = {
            width:500,
            consultaId: "00000000-0000-0000-0000-000000000000",
            editModeProp: true
        };

        this.setActiveTask({task:'alta-consulta', props: params})
    },
    async procesarReporte(){

      var self = this;

      try {
            self.loading = true;

      let params = [];
      params.push({
        "Documento": this.filtro.documento, 
        "Telefono": this.filtro.telefono,
        "Nombre": this.filtro.nombre, 
        "FechaDesde": this.filtro.periodo.desde,
        "FechaHasta": this.filtro.periodo.hasta, 
        
      } );

      console.log(params)
      
        this.setReporteActivo({reporte: 'ManejoDeConsultas.trdp', params: params})

        window.open('/report-viewer');
      } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    
    async editItem(item){
        this.selectedRow[0] = item;
        var params = {  width:500,
                        consultaId: item.id,
                        editModeProp: true }
        
        Vue.$log.debug('editItem');

        this.setActiveTask({task:'alta-consulta', props: params})
    },
    async viewItem(item){
        this.selectedRow[0] = item;
        var params = {  width:500,
                        consultaId: item.id,
                        editModeProp: false }

        this.setActiveTask({task:'alta-consulta', props: params})
    }, 
    
  }
}
</script>